import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { map } from 'rxjs/operators';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatChipInputEvent } from '@angular/material/chips';
import { of } from 'rxjs';
import { FormControl } from '@angular/forms';
import { PractitionRoleService } from '../../../../../../../core/lists';

@Component({
  selector: 'kt-categorys',
  templateUrl: './condition-category.component.html',
  styleUrls: ['./condition-category.component.scss'],
})
export class ConditionCategoryComponent implements OnInit {
  selectable = true;
  removable = true;
  filteredCategorys;
  @ViewChild('categoryInput') entityInput: ElementRef<HTMLInputElement>;
  categoryList: any = [];
  categoryValue: any;
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];
  @Input() controlObject: FormControl;
  @Input() readOnlyValue;
  @Input() appearance;
  @Input() readOnly = false;
  @Input() isReadOnly;
  @Input() value;

  disable = false;
  constructor(private practitionRoleService: PractitionRoleService) {}

  ngOnInit(): void {
    if (this.readOnly) {
      this.selectable = false;
      this.removable = false;
      this.categoryList = [...this.readOnlyValue];
    } else {
      this.controlObject.valueChanges.subscribe((value) => {
        if (!value) {
          this.categoryList = [];
          this.entityInput.nativeElement.value = '';
        }
      });
    }

    if (this.value) {
      this.value.subscribe((value) => {
        this.categoryList = value;
        this.updateModel();
      });
    }
  }

  categoryInputChanged(value) {
    if (value) {
      if (typeof value === 'string')
        this.filteredCategorys = this.practitionRoleService.searchCode(value).pipe(
          map((res) =>
            res.items.filter((r) => {
              return !this.categoryList.find((e: any) => e.concept.id === r.concept.id);
            }),
          ),
        );
    } else {
      this.filteredCategorys = of([]);
    }
  }

  getCategoryDescription(category) {
    return category.concept.fsn.term;
  }

  remove(entity: string): void {
    const index = this.categoryList.indexOf(entity);

    if (index >= 0) {
      this.categoryList.splice(index, 1);
    }

    this.updateModel();
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    this.categoryList.push(event.option.value);
    this.entityInput.nativeElement.value = '';
    this.updateModel();
  }

  add(event: MatChipInputEvent): void {
    const value = event.value;
    if ((value || '').trim()) {
      this.categoryList.push({ name: value.trim() });
      this.entityInput.nativeElement.value = '';
    }

    this.updateModel();
  }

  updateModel() {
    this.controlObject.setValue(
      this.categoryList.map((category) =>
        category.concept.id ? { id: category.concept.id } : { name: category.concept.fsn.term },
      ),
    );
  }
}
